function changeSubtotal(data) {
  if (document.querySelector('input[data-quantity-input]')) {
      setTimeout(()=>{
          let number = document.querySelector('input[data-quantity-input]').value
         let variant = BSS_B2B.storage.variantStorage.get(Number(data))
         if (variant && variant.bssB2BPriceAfterCP) {
         let sub =  document.querySelector('[bss-button-price]')
            sub.classList.add('bss_custom')
         sub.innerHTML = `${BSS_B2B.formatMoney(variant.bssB2BPriceAfterCP* Number(number) )}`
        }
      }, 100)
    }
  }

document.addEventListener("DOMContentLoaded", function () {
  let buttonChangeQuantity = document.querySelectorAll('.quantity__button')
  if (buttonChangeQuantity.length) {
    buttonChangeQuantity.forEach((e)=>{
      e.addEventListener('click', ()=>{
        let attribute = document.querySelector('[bss-button-price]').getAttribute('variant-id')
         changeSubtotal(attribute)
      })
    })
  }
  setTimeout(()=>{
     let attribute = document.querySelector('[bss-button-price]').getAttribute('variant-id')
     changeSubtotal(attribute)
  }, 1000)
});